<template>
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pb-10 pr-3 pl-3" v-else-if="!ajaxCallInProgress">
            <!-- Breadcrumb section -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                    <div class="breadcrumbnew">
                        <div>
                            <router-link to="/salesDashboard" class="text-white pl-2 text-line">Sales Dashboard
                            </router-link>
                        </div>
                        <span>Leads</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <button v-if="userPermissions.leads.permitted_actions.create"
                            class="btn btn-des-small ml-2 mr-6 text-white"
                            @click="$router.push('/leads/createLeads/new')" style="background:#128807; height:30px">+
                            Create New Lead</button>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="dropdown-label">Period : </div>
                            <div class="dropdown perioddropdown">
                                <ul class='nav nav-tabs'>
                                    <li class='nav-item dropdown'>
                                        <a aria-expanded='false' aria-haspopup='true'
                                            class='nav-link dropdown-toggle dropdown-button on-focus'
                                            data-toggle='dropdown' href='#' role='button'>
                                            <span v-if="this.period_data == 'fiscal_year'">Fiscal Year</span>
                                            <span v-if="period_data == 'h1'">Semi Annual H1</span>
                                            <span v-if="period_data == 'h2'">Semi Annual H2</span>
                                            <span v-if="period_data == 'q1'">Quarter Q1</span>
                                            <span v-if="period_data == 'q2'">Quarter Q2</span>
                                            <span v-if="period_data == 'q3'">Quarter Q3</span>
                                            <span v-if="period_data == 'q4'">Quarter Q4</span>
                                            <span v-if="this.period_data == 'month'">Month</span>
                                        </a>
                                        <div class='dropdown-menu period-dropdown-menu'>
                                            <a @click="getData('fiscal_year')" class='dropdown-item' href='#'>Fiscal
                                                Year</a>
                                            <div class='dropdown-item dropdown-submenu period-dropdown'>
                                                <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown'
                                                    href='#'>Semi-Annual</a>
                                                <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                                    <a @click="getData('h1')" class='dropdown-item' href='#'>H1</a>
                                                    <a @click="getData('h2')" class='dropdown-item' href='#'>H2</a>
                                                </div>
                                            </div>
                                            <div class='dropdown-item dropdown-submenu period-dropdown'>
                                                <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown'
                                                    href='#'>Quarter</a>
                                                <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                                    <a @click="getData('q1')" class='dropdown-item' href='#'>Q1</a>
                                                    <a @click="getData('q2')" class='dropdown-item' href='#'>Q2</a>
                                                    <a @click="getData('q3')" class='dropdown-item' href='#'>Q3</a>
                                                    <a @click="getData('q4')" class='dropdown-item' href='#'>Q4</a>
                                                </div>
                                            </div>
                                            <a @click="getData('month')" class='dropdown-item' href='#'>Month</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Counts section -->
            <div class="row pt-1 pl-4 pr-4">
                <div class="col-md-2 col-sm-4 col-lg-2  pl-3 pr-5 pb-3 div-space" v-for="(data,value) of analysis_data"
                    :key="value">
                    <div class="widget widget2 card-item bg-white text-auto">
                        <div class="fw-600 text-center fs-16 text-data">{{value}}</div>
                        <h1 class="mt-3 text-new-violet fs-14 text-center">{{data}}</h1>
                    </div>
                </div>
                <!-- <div class="col-md-2 col-sm-4 col-lg-2  pl-3 pr-3 pb-3  div-space">
                    <div class="widget widget2 card-item bg-white text-auto">
                        <div class="fw-600 text-center fs-16">Unqualified</div>
                        <h1 class="mt-3 text-new-violet fs-14 text-center">212</h1>

                    </div>
                </div>
                <div class="col-md-2 col-sm-4 col-lg-2  pl-3 pr-3 pb-3  div-space">
                    <div class="widget widget2 card-item bg-white text-auto">
                        <div class="fw-600 text-center fs-16">Qualified</div>
                        <h1 class="mt-3 text-new-violet fs-14 text-center">212</h1>

                    </div>
                </div>
                <div class="col-md-2 col-sm-4 col-lg-2  pl-3 pr-3 pb-3  div-space">
                    <div class="widget widget2 card-item bg-white text-auto">
                        <div class="fw-600 text-center fs-16">Contacts</div>
                        <h1 class="mt-3 text-new-violet fs-14 text-center">212</h1>
                    </div>
                </div>
                <div class="col-md-2 col-sm-4 col-lg-2  pl-3 pr-3 pb-3  div-space">
                    <div class="widget widget2 card-item bg-white text-auto">
                        <div class="fw-600 text-center fs-16">Customers</div>
                        <h1 class="mt-3 text-new-violet fs-14 text-center">212</h1>
                    </div>
                </div>
                <div class="col-md-2 col-sm-4 col-lg-2  pl-3 pr-3 pb-3  div-space">
                    <div class="widget widget2 card-item bg-white text-auto">
                        <div class="fw-600 text-center fs-16">Territory</div>
                        <h1 class="mt-3 text-new-violet fs-14 text-center">212</h1>
                    </div>
                </div> -->
            </div>
            <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7 p-0">
                    <!-- Lead Converted by source section -->
                    <div class="col-lg-12 col-sm-12 col-md-12 p-0 pr-3 pl-6">
                        <fullscreen ref="source" @change="dataChange('source')" class="box-radius bg-white">
                            <div class="card-item bg-white text-auto pb-0" style="height: 493px !important">
                                <div class="d-flex justify-content-between aling-items-center">
                                    <div class="fw-600 fs-14">Leads converted by Source</div>
                                    <div>
                                        <!--el-select v-model="source" class="select-css drop-data"  @change="sourceChange()" :popper-append-to-body="false">
                                            <el-option v-for="(time, index) in lead_source_options" :key="index" :label="time" :value="time" class="text-capitialize">
                                            </el-option>
                                        </el-select-->
                                        <button type="button" class="pointer bg-white icon-outline-css"
                                            @click="expandData('source') , addClass()"><img class="expand-img"
                                                src="/static/images/exapand.svg" alt />
                                        </button>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadLeadsConvertedSection" style="height: 417px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-3" id="convertedDataDiv">
                                        <div class="mt-3">
                                            <div class="fw-600 fs-14 mt-10">Conventional</div>
                                            <span
                                                class="text-new-blue fs-14 mb-10">{{count_num.conventional_count || '--'}}</span>
                                            <div class="fw-600 fs-14 mt-10">Social Media</div>
                                            <span
                                                class="text-new-blue fs-14">{{count_num.social_media_count || '--' }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-9">
                                        <div id="convertedLeadDiv" class="mt-3"></div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12" id="legenddiv"></div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Territory section -->
                    <div class="col-lg-12 col-sm-12 col-md-12 pt-3 pl-6 pr-3">
                        <fullscreen ref="territory" @change="dataChange('territory')" class="box-radius bg-white">
                            <div class="card-item bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Territory (Customer Distribution)</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('territory'), addClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadTerritorySection" style="height: 377px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div id="territoryDiv" class="mt-3">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 p-0">
                    <!-- Leads list view table section -->
                    <div class="col-lg-12 col-sm-12 col-md-12 p-0 pr-6">
                        <fullscreen ref="leadslist" @change="dataChange('leadslist')" class="box-radius bg-white leadFullscreen">
                            <div class="card-item bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Leads List View</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('leadslist')">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div id="leadsListTableDiv" class="mt-3">
                                            <table class="table-lead text-center w-100 head-css">
                                                <thead class="bg-blue">
                                                    <tr>
                                                        <th class="text-left pl-2">LEAD NAME</th>
                                                        <th class="text-left">COMPANY NAME</th>
                                                        <th class="text-rightt">LEAD TYPE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="w-100" v-if="loadListViewSection">
                                                        <td colspan="15">
                                                            <div class="d-flex align-items-center justify-content-center w-100"
                                                                v-if="loadListViewSection">
                                                                <half-circle-spinner :animation-duration="1000"
                                                                    :size="50" color="#00448b"
                                                                    style="margin: 0 auto;" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="!loadListViewSection && lead_data.length == 0"
                                                        class="text-center">
                                                        <td colspan="3" calss="text-center">
                                                            <img src="/static/images/territory-sales.png"
                                                                class="mb-3 pt-50 data-text sales_territory_css list-lead-img" />
                                                                <p class="text-center text-muted fw-500 mt-4">No leads to display!</p>
                                                        </td>
                                                    </tr>
                                                    <tr v-else-if="!loadListViewSection && lead_data.length != 0" v-for="(leads, index) in lead_data" :key="index" style="vertical-align: baseline;">
                                                        <td class="text-capitalize text-left new-blue-text pointer text-lead-ellipsis" :title="leads.full_name" @click="viewLead(leads.id)">
                                                            {{leads.full_name || '-'}}</td>
                                                        <td class="text-capitalize text-black text-left text-lead-ellipsis-company">
                                                            {{leads.company_name || '-'}}</td>
                                                        <td>
                                                            <span class="text-capitalize text-left"
                                                                :class="{'cold_lead':leads.lead_type == 'cold_lead','warm_lead':leads.lead_type == 'warm_lead','hot_lead':leads.lead_type == 'hot_lead'}">{{ leads.lead_type.replace(/_/g, " ") || "-" }}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </fullscreen>
                    </div>
                    <!-- <div class="col-lg-12 col-sm-12 col-md-6 p-0 pr-6">
                        <fullscreen ref="meetings" @change="dataChange('meetings')" class="box-radius bg-white">
                            <div class="card-item bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600">Schedule Meetings</div>
                                    <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('meetings')">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>

                                </div>
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class='slant-tabs'
                                        :class="{'activeTab':active_tab == 'meetings','new-blue':active_tab == 'meetings'}"
                                        @click="switchTabs('meetings')">
                                        <span class="text-capitalize">Meetings</span>
                                    </div>
                                    <div class="slant-tabs ml-2"
                                        :class="{'activeTab':active_tab == 'reminders','new-blue':active_tab == 'reminders'}"
                                        @click="switchTabs('reminders')">
                                        <span class="text-capitalize">Reminders</span>
                                    </div>
                                    <div class="slant-tabs ml-2"
                                        :class="{'activeTab':active_tab == 'notes','new-blue':active_tab == 'notes'}"
                                        @click="switchTabs('notes')">
                                        <span class="text-capitalize">Notes</span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between aline-items-center float-right">
                                    <button class="btn btn-des-small ml-2 mr-2 float-right text-white"
                                        style="background: #00448b; border: 1px solid #00448b">+Add</button>
                                </div>
                                <div class="no-data mt-3">
                                    <div style="width: 200px; margin: auto;">
                                        <img class="justify-content-between" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/schedule_meeting.svg">
                                        <div class="justify-content-between text-center ">Schedule A meeting to interact with your lead</div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div id="" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-md-6 pt-3 p-0 pr-6">
                        <fullscreen ref="history" @change="dataChange('history')" class="box-radius bg-white">
                            <div class="card-item bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600">History</div>
                                    <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('history')">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>

                                </div>
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class='slant-tabs'
                                        :class="{'activeTab':active_tab == 'historyMeetings','new-blue':active_tab == 'historyMeetings'}"
                                        @click="switchHistory('historyMeetings')">
                                        <span class="text-capitalize">Meetings</span>
                                    </div>

                                    <div class="slant-tabs ml-2"
                                        :class="{'activeTab':active_tab == 'chats','new-blue':active_tab == 'chats'}"
                                        @click="switchHistory('chats')">
                                        <span class="text-capitalize">Chats</span>
                                    </div>
                                    <div class="slant-tabs ml-2">
                                        <span class="text-capitalize"></span>
                                    </div>
                                </div>

                                <div class="no-data justify-content-between">
                                    <div style="width: 200px; margin: auto;">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/add_reminders.svg">
                                        <div>You don't have any Reminders yet!</div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div id="historyDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div> -->
                </div>
            </div>
            <div class="row mt-3">
                <!-- Customers and Contacts section -->
                <div class="col-lg-6 col-sm-12 col-md-6 pl-6 pr-3 p-0">
                    <fullscreen ref="customer" @change="dataChange('customer')" class="box-radius bg-white">
                        <div class="card-item bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-14">Customers and Contacts</div>
                                <button type="button" class="pointer bg-white icon-outline-css"
                                    @click="expandData('customer') , addClass()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadCustomersContactsSection" style="height: 411px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12">
                                    <div id="contactDiv" class="mt-3"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Lead Trends section -->
                <div class="col-lg-6 col-sm-12 col-md-6 pr-6 p-0">
                    <fullscreen ref="trends" @change="dataChange('trends')" class="box-radius bg-white">

                        <div class="card-item bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center mt-1">
                                <div class="fw-600 fs-14">Lead Trends</div>
                                <button type="button" class="pointer bg-white icon-outline-css"
                                    @click="expandData('trends') , addClass()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="p-1 mt-2">
                                <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                        <input type="text"
                                            :value="('0'+new Date(dateRange[0]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                            style="color: #fff; background: #41b883; width: 14em;" disabled />
                                        <span @click="dataClose('report'),dateRange= []"
                                            style="color: #fff; cursor: pointer;">&#10005;</span>
                                    </div>
                                </div>
                                <date-picker v-else @change="updatecreationDate()" v-model="dateRange"
                                    format="DD/MM/YYYY" range
                                    class="date-width calendar-edit-per callreport-listdate calendar-height-top"
                                    :show-second="false" :lang="lang" :clearable="true" confirm :not-after="new Date()"
                                    confirm-text="APPLY" type="date">
                                </date-picker>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadLeadTrendsSection" style="height: 358px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12">
                                    <div id="trendsDiv" class="mt-3"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
    </div>
</template>
<script>
    import dashboard from '../mixins/dashboard'
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import convert from "../mixins/convert.js";
    import leads from "../mixins/leads"
    export default {
        data() {
            return {
                loadCustomersContactsSection: false,
                loadListViewSection: false,
                loadTerritorySection: false,
                loadLeadsConvertedSection: false,
                loadLeadTrendsSection: false,
                lead_data: [],
                grpah_scale: [],
                filters: {
                    lead_name: [],
                    lead_source: [],
                    lead_type: [],
                    assigned_to: [],
                    date_range: "",
                },
                show: false,
                source_conversion: [],
                media_conversion: [],
                chart: {},
                selected_type: "today",
                select_month: null,
                open: false,
                source: 'month',
                time_period: 'fiscal_year',
                period_data: 'fiscal_year',
                lead_source_options: ['month', 'year', 'today', 'week'],
                souce: 'Year',
                between: '',
                active_tab: 'meetings',
                showTerritory: false,
                warning_msg: '',
                success_msg: '',
                analysis_data: [],
                lead_trends_data: [],
                ajaxCallInProgress: false,
                created_report_date: [new Date(), new Date()],
                rangeDate: [],
                dateRange: [],
                creation_date: [],
                count_num: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                lang: {
                    type: "en",
                    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    months: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    pickers: [
                        "next 7 days",
                        "next 30 days",
                        "previous 7 days",
                        "previous 30 days"
                    ],
                    placeholder: {
                        date: "Select Date",
                        dateRange: "Select Date Range"
                    },
                },
            }
        },
        components: {
            SweetModal,
            HalfCircleSpinner,
        },
        mixins: [dashboard, convert, leads],
        methods: {
            //Redirect to the view lead page
            /**@params = id */
            viewLead(id) {
                if(this.userPermissions.leads.permitted_actions.view){
                    localStorage.setItem("leads_type",'Manual')
                    this.$router.push('/leads/viewLeads/' + id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //Get the leads from APi call
            /**@params = id */
            async getLeads() {
                this.loadListViewSection = true;
                /**@params = skip, @params = limit, @params = period, @params = between */
                let params = {
                    limit: 15,
                    skip: 0,
                    period: this.time_period,
                    between: this.between
                };
                let response = await this.getLeadListData(params)
                this.lead_data = response.response;
                this.total = response.count;
                this.start = this.count * this.limit + 1;
                this.end = this.count * this.limit + this.limit < this.total ? this.count * this.limit + this
                    .limit : this.total;
                this.$forceUpdate()
                this.loadListViewSection = false
            },
            //change the date format and set into the range
            dateSettings() {
                let date = []
                var dateOffset = (24 * 60 * 60 * 1000) * (365 * 5); //5 yrs
                var newDate = this.convertFilter(new Date());
                var oldDate = new Date();
                oldDate.setTime(oldDate.getTime() - dateOffset);
                this.created_report_date = [this.convertFilter(oldDate), newDate]
                this.rangeDate = [this.convertFilter(oldDate), newDate]
            },
            //convert the date format
            /**@params = val */
            dataClose(val) {
                let date = this.rangeDate
                let start_date = this.convertFilter(date[0])
                let end_date = this.convertFilter(date[1])
                let newValue = start_date + ',' + end_date
                newValue = newValue.split(",")
                this.created_report_date = newValue
                this.loadLeadTrendsDataAPI()
            },
            updatecreationDate() {
                if (this.dateRange) {
                    let start_date = this.convertFilter(this.dateRange[0])
                    let end_date = this.convertFilter(this.dateRange[1])
                    let newValue = start_date + ',' + end_date
                    newValue = newValue.split(",")
                    this.created_report_date = newValue
                    this.loadLeadTrendsDataAPI()
                } else {
                    this.creation_date = ''
                    this.created_report_date = ''
                }
                this.$forceUpdate()

            },
            //get the data from fiscal year dropdown
            /**@params = value */
            getData(value) {
                this.period_data = value
                if (value == 'h1' || value == 'h2') {
                    this.time_period = 'semi_annual'
                    this.between = value
                } else if (value == 'q1' || value == 'q2' || value == 'q3' || value == 'q4') {
                    this.time_period = 'quarter'
                    this.between = value
                } else {
                    this.time_period = value
                    this.between = ''
                }
                this.loadContactCustomer()
                this.leadDistribution()
                this.loadLeadTrendsDataAPI()
                this.getLeads()
            },
            sourceChange() {
                // this.loadSourceConversionDataAPI()
            },
            //show the montha dn year dropdown
            async showMonthDropdown() {
                this.open = true
            },
            //swtich the tabs between meetings, reminders and notes
            /**@params = obj */
            switchTabs(obj) {
                if (obj == 'meetings') {
                    this.active_tab = 'meetings'
                    this.meetings = true
                    this.reminders = false
                    this.notes = false
                } else if (obj == 'reminders') {
                    this.active_tab = 'reminders'
                    this.meetings = false
                    this.reminders = true
                    this.notes = false
                } else if (obj == 'notes') {
                    this.active_tab = 'notes'
                    this.meetings = false
                    this.reminders = false
                    this.notes = true
                }
            },
            //swtich the history of the data between meetings, chats
            switchHistory(obj) {
                if (obj == 'historyMeetings') {
                    this.active_tab = 'historyMeetings'
                    this.historyMeetings = true
                    this.chats = false

                } else if (obj == 'chats') {
                    this.active_tab = 'chats'
                    this.historyMeetings = false
                    this.chats = true
                }
            },
            handleChange(value, type) {
                if (type === 'second') {
                    this.open = false;
                }
            },
            display() {
                this.show = !this.show
            },
            async showMonthPicker() {
                this.open = true
            },
            //APi call to load source conversion data
            async loadSourceConversionDataAPI() {
                this.loadLeadsConvertedSection = true;
                try {
                    let params = {
                        period: this.source
                    }
                    let response = await this.getSourceConversionData(params)
                    this.count_num = response.response
                    this.source_conversion = response.response.conversion
                    const result = []
                    for (const item of this.source_conversion) {
                        result.push({
                            year: item.date
                        });
                        let index_of_p_cat = result.findIndex(object => {
                            return object.year === item.date;
                        });
                        item.conventional.forEach((element, index) => {
                            result[index_of_p_cat]['conventional' + (index + 1)] = element.converted_count;
                        })
                        item.social_media.forEach((element, index) => {
                            result[index_of_p_cat]['social_media' + (index + 1)] = element.converted_count;
                        })
                    }
                    this.source_conversion = result
                    if (this.count_num.conventional_count == 0 && this.count_num.social_media_count == 0) {
                        this.loadLeadsConvertedSection = true;
                        setTimeout(() => {
                            this.loadLeadsConvertedSection = false;
                            var style = document.createElement('style');
                            style.type = 'text/css';
                            style.innerHTML =
                                '.imgCss {width: 250px !important;height: 200px!important;margin: auto!important;}';
                            document.getElementsByTagName('head')[0].appendChild(style);
                            document.getElementById('convertedLeadDiv').innerHTML =
                                "<div class=text-center><img id= convention-img src=/static/images/response.png class=mt-3><div class='mt-4 text-muted fw-500'>No leads added!</div></div></div>";
                            document.getElementById('convention-img').className = 'imgCss';
                        }, 1500);
                    } else {
                        this.loadLeadsConvertedSection = false;
                        this.loadSourceConversionData();
                    }
                    this.loadLeadsConvertedSection = false;
                } catch (reason) {
                    this.loadLeadsConvertedSection = false;
                }
            },
            //set thte data into source conversion
            loadSourceConversionData() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("convertedLeadDiv", am4charts.XYChart);
                    // Add data
                    chart.data = vueThis.source_conversion;
                    chart.responsive.enabled = true;
                    // Create axes

                    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "year";
                    categoryAxis.title.text = "Date";
                    categoryAxis.title.fontWeight = 600;
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.renderer.labels.template.horizontalCenter = "right";
                    categoryAxis.renderer.labels.template.verticalCenter = "middle";
                    categoryAxis.renderer.labels.template.rotation = 270;
                    categoryAxis.renderer.grid.template.strokeWidth = 0;
                    categoryAxis.renderer.minGridDistance = 20;
                    categoryAxis.renderer.cellStartLocation = 0.1;
                    categoryAxis.renderer.cellEndLocation = 0.9;
                    categoryAxis.tooltip.label.maxWidth = 120;
                    categoryAxis.tooltip.label.wrap = true;
                    categoryAxis.events.on("sizechanged", function (ev) {
                        var axis = ev.target;
                        var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
                        axis.renderer.labels.template.maxWidth = cellWidth;
                    });
                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.min = 0;
                    valueAxis.title.text = "Leads count";
                    valueAxis.title.fontWeight = 600;

                    // Create series
                    function createSeries(field, name, stacked) {
                        var series = chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueY = field;
                        series.dataFields.categoryX = "year";
                        series.name = name;
                        series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
                        series.stacked = stacked;
                        series.columns.template.width = am4core.percent(70);
                        series.scrollable = true;

                        let bullet1 = series.bullets.push(new am4charts.LabelBullet());
                        bullet1.interactionsEnabled = false;
                        bullet1.label.text = "{valueY.formatNumber('#.00')} ";
                        bullet1.label.fill = am4core.color("#ffffff");
                        bullet1.locationY = 0.5;
                    }

                    createSeries("conventional1", "Others", false);
                    createSeries("social_media1", "Facebook", false);
                    createSeries("social_media2", "Instagram", true);
                    createSeries("social_media3", "LinkedIn", true);
                    createSeries("social_media4", "Twitter", true);



                    // Add legend
                    chart.legend = new am4charts.Legend();
                    chart.scrollbarX = new am4core.Scrollbar();

                    /* Create a separate container to put legend in */
                    var legendContainer = am4core.create("legenddiv", am4core.Container);
                    legendContainer.width = am4core.percent(100);
                    legendContainer.height = am4core.percent(100);
                    chart.legend.parent = legendContainer;
                }, 1500);
            },
            //Api call to load contact and customer
            async loadContactCustomer() {
                /**@params = period, @params = between */
                this.loadCustomersContactsSection = true;
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getLeadCompare(params)
                this.contact_data = response.response
                const result = []
                for (const item of this.contact_data) {
                    result.push({
                        time: item.time,
                        contacts: item.contacts,
                        customers: item.customers
                    });
                }
                this.contact_data = result
                if (this.contact_data == '') {
                    this.loadCustomersContactsSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.imgCss {width: 300px !important;height: 250px!important;margin: auto!important;margin-top:20px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('contactDiv').innerHTML =
                            "<div class=text-center><img id= contact-img src=/static/images/industry-type-survey.png class=mt-3></div><div class='mt-4 text-muted fw-500'>No survey responses added!</div></div>";
                        document.getElementById('contact-img').className = 'imgCss';
                    }, 1500);
                } else {
                    this.loadCustomersContactsSection = false;
                    this.loadContactDetails()
                }
                this.loadCustomersContactsSection = false;
            },
            //load the contact details and set into the graph
            loadContactDetails() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("contactDiv", am4charts.XYChart);
                    // Add data
                    chart.data = vueThis.contact_data
                    // Create axes
                    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "time";
                    categoryAxis.title.text = "Time"
                    categoryAxis.fontWeight = 600;
                    categoryAxis.numberFormatter.numberFormat = "#";
                    categoryAxis.renderer.inversed = true;
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.renderer.cellStartLocation = 0.1;
                    categoryAxis.renderer.cellEndLocation = 0.9;
                    categoryAxis.renderer.minGridDistance = 50;
                    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                    valueAxis.renderer.opposite = false;
                    valueAxis.renderer.minGridDistance = 50;

                    chart.legend = new am4charts.Legend();
                    // Create series
                    function createSeries(field, name) {
                        var series = chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueX = field;
                        series.dataFields.categoryY = "time";
                        series.name = name;
                        series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
                        series.columns.template.height = am4core.percent(100);
                        series.sequencedInterpolation = true;
                        var valueLabel = series.bullets.push(new am4charts.LabelBullet());
                        valueLabel.label.text = "{valueX}";
                        valueLabel.label.horizontalCenter = "left";
                        valueLabel.label.dx = 20;
                        valueLabel.label.truncate = true;


                        var categoryLabel = series.bullets.push(new am4charts.LabelBullet());
                        categoryLabel.label.text = "{name}";
                        categoryLabel.label.horizontalCenter = "right";
                        categoryLabel.label.dx = -10;
                        categoryLabel.label.fill = am4core.color("#fff");
                        categoryLabel.label.truncate = true;
                    }
                    createSeries("contacts", "Contacts");
                    createSeries("customers", "Customers");
                }, 1500);
            },
            //Api call to laod lead trends data
            async loadLeadTrendsDataAPI() {
                this.loadLeadTrendsSection = true;
                try {
                    let params = {
                        range: this.created_report_date
                    }
                    let response = await this.getLeadTrendsData(params)
                    this.lead_trends_data = response.response.timing
                    const result = []
                    const map = new Map();
                    for (const item of this.lead_trends_data) {
                        map.set(item.total, true);
                        result.push({
                            date: item.concat_time || '',
                            value: item.total
                        });
                    }
                    this.graph_scale = response.response.graph_scale
                    const scale = []
                    for (const scaledata of this.graph_scale) {
                        scale.push(scaledata)
                    }

                    this.graph_scale = scale
                    this.lead_trends_data = result
                    this.loadLeadTrendsSection = false;
                } catch (reason) {
                    this.loadLeadTrendsSection = false;
                }
                if (this.graph_scale == '') {
                    this.loadLeadTrendsSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.imgCss {width: 50%!important;height: 50%!important;margin:auto!important;margin-top:20px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('trendsDiv').innerHTML =
                            "<div class=text-center><img id= trend-img src=/static/images/response.png class=mt-3><div class='mt-4 text-muted fw-500'>No leads added!</div></div>";
                        document.getElementById('trend-img').className = 'imgCss';
                    }, 1000);
                } else {
                    this.loadLeadTrendsSection = false;
                    this.loadLeadTrendsData()
                }
            },
            //Set the response into the trends graph
            loadLeadTrendsData() {
                setTimeout(() => {
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    var chart = am4core.create("trendsDiv", am4charts.XYChart);
                    chart.paddingRight = 20;
                    var data = [];
                    var visits = 10;
                    for (var i = 1; i < 50000; i++) {
                        visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
                        data.push({
                            date: new Date(2018, 0, i),
                            value: visits
                        });
                    }
                    chart.data = this.lead_trends_data;
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.grid.template.location = 0;
                    dateAxis.minZoomCount = 0;
                    dateAxis.title.text = "Time"
                    dateAxis.fontWeight = 500;
                    // this makes the data to be grouped
                    dateAxis.groupData = true;
                    dateAxis.groupCount = 500;
                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.numberFormatter.numberFormat = "#a";
                    valueAxis.title.text = "Lead Count"
                    valueAxis.fontWeight = 500;
                    //create label
                    var ylabel = valueAxis.renderer.labels.template;
                    ylabel.truncate = true;
                    ylabel.maxWidth = 80;
                    ylabel.tooltipText = "{value}";

                    var series = chart.series.push(new am4charts.LineSeries());
                    series.dataFields.dateX = "date";
                    series.dataFields.valueY = "value";
                    series.tooltipText = "{valueY}";
                    series.tooltip.pointerOrientation = "vertical";
                    series.tooltip.background.fillOpacity = 0.5;

                    chart.cursor = new am4charts.XYCursor();
                    chart.cursor.xAxis = dateAxis;


                    var scrollbarX = new am4core.Scrollbar();
                    scrollbarX.marginBottom = 20;
                    chart.scrollbarX = scrollbarX;
                }, 1000);
            },
            //Api call to get the lead analytics
            async leadAnalytics() {
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getLeadAnalyticsData(params)
                let arr = []
                arr = response.response
                this.analysis_data = arr
                delete arr['contact_percentage'];
                delete arr['customer_percentage'];
                delete arr['qualified_percentage'];
                delete arr['unqualified_percentage'];
                this.ajaxCallInProgress = false;
            },
            //API call to get the lead distribution
            async leadDistribution() {
                /**@params = period, @params = between */
                this.loadTerritorySection = true;
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getLeadDistribution(params)
                this.distribution_data = response.response
                const result = []
                for (const item of this.distribution_data) {
                    result.push({
                        name: item.country,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        hcenter: "left",
                        vcenter: "middle",
                        value: item.count
                    });
                }
                this.distribution_data = result
                this.loadTerritorySection = false;
                this.loadTerritoryData()
            },
            async loadTerritoryData() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("territoryDiv", am4maps.MapChart);
                    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

                    chart.geodata = am4geodata_worldLow;
                    chart.projection = new am4maps.projections.Miller();

                    var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
                    polygonSeries.useGeodata = true;

                    var polygonTemplate = polygonSeries.mapPolygons.template;
                    polygonTemplate.fill = am4core.color("#cce3fc");

                    // Exclude Antartica
                    polygonSeries.exclude = ["AQ"];

                    var placeSeries = chart.series.push(new am4maps.MapImageSeries());
                    var place = placeSeries.mapImages.template;
                    place.nonScaling = true;
                    place.propertyFields.latitude = "latitude";
                    place.propertyFields.longitude = "longitude";

                    placeSeries.data = vueThis.distribution_data
                    var circle = place.createChild(am4core.Circle);
                    circle.radius = 4;
                    circle.fill = am4core.color("#e6ff00");
                    circle.stroke = am4core.color("#000");
                    circle.strokeWidth = 1;

                    var label = place.createChild(am4core.Label);
                    label.padding(10, 10, 10, 10);
                    label.propertyFields.text = "name";
                    label.propertyFields.tooltipText = "value";
                    label.propertyFields.horizontalCenter = "hcenter";
                    label.propertyFields.verticalCenter = "vcenter";
                    label.fill = am4core.color("#e6ff00");
                    label.stroke = am4core.color("#000");
                    label.strokeWidth = 1;
                    label.fontWeight = 800;
                }, 1500);
            },
            addClass() {
                var source = document.getElementById('convertedLeadDiv');
                source.classList.toggle('convertedLeadDiv-expand');
                var trends = document.getElementById('trendsDiv');
                trends.classList.toggle('trendsDiv-expand');
                var territory = document.getElementById('territoryDiv');
                territory.classList.toggle('territoryDiv-expand');
                var contact = document.getElementById('contactDiv');
                contact.classList.toggle('contactDiv-expand');
                var history = document.getElementById('historyDiv');
                history.classList.toggle('historyDiv-expand');
            },
            //expand to full screen
            /**@params = value */
            expandData(value) {
                if (value == 'source') {
                    this.$refs["source"].toggle();
                } else if (value == 'meetings') {
                    this.$refs["meetings"].toggle();
                } else if (value == 'trends') {
                    this.$refs["trends"].toggle();
                } else if (value == 'territory') {
                    this.$refs["territory"].toggle();
                    this.addClass();
                } else if (value == 'history') {
                    this.$refs["history"].toggle();
                } else if (value == 'customer') {
                    this.$refs["customer"].toggle();
                } else if (value == 'leadslist') {
                    this.$refs["leadslist"].toggle();
                }
            },
            dataChange(value) {
                if (value == 'source') {
                    this.source = value;
                } else if (value == 'territory') {
                    this.territory = value;
                    this.addClass();
                } else if (value == 'trends') {
                    this.trends = value;
                } else if (value == 'meetings') {
                    this.meetings = value;
                } else if (value == 'history') {
                    this.history = value;
                } else if (value == 'customer') {
                    this.customer = value;
                } else if (value == 'leadslist') {
                    this.leadslist = value;
                }
            }
        },
        computed: {
            userPermissions() {
                return this.$store.getters.userPermissions;
            },
        },
        watch: {
            selected_type() {
                if (this.selected_type == 'month') {
                    this.open = true
                } else {
                    this.open = false
                }
            }
        },
        async mounted() {
            this.ajaxCallInProgress = true,
            this.dateSettings()
            //this.loadConvertedSource(),
            this.loadContactCustomer(),
            this.leadDistribution(),
            this.leadAnalytics(),
            this.loadSourceConversionDataAPI(),
            this.loadLeadTrendsDataAPI(),
            this.loadSourceConversionData(),
            this.getLeads();
            setTimeout(() => {
                (function () {
                    $(function () {
                        $('.period-dropdown > a').on('click', function (e) {
                            var submenu;
                            submenu = $(this);
                            $('.period-dropdown .period-dropdown-menu').removeClass('show');
                            submenu.next('.period-dropdown-menu').addClass('show');
                            e.stopPropagation();
                        });
                        return $('.perioddropdown').on('hidden.bs.dropdown', function () {
                            // hide any open menus when parent closes
                            $('.period-dropdown-menu.show').removeClass('show');
                        });
                    });
                }).call(this);
                    this.ajaxCallInProgress = false
            }, 1000);
        },

    }
</script>
<style scoped>
    .table-lead thead tr th:first-child{
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
     .table-lead thead tr th:last-child{
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .text-lead-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        width: 150px;
        white-space: nowrap;
    }
    .text-lead-ellipsis-company {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        width: 150px;
        white-space: nowrap;
    }
    .hot_lead {
        background: #fce5e5;
        color: #e82828;
        border: solid 1px #e82828;
        border-radius: 5px;
        padding: 6px 34px 6px 17px;
    }

    .warm_lead {
        background: #ffecd1;
        color: #ff9a06;
        border: solid 1px #ff9a06;
        border-radius: 5px;
        padding: 6px 17px 6px 17px;
    }

    .cold_lead {
        background: #c5daf8;
        color: #00448b;
        border: solid 1px #00448b;
        border-radius: 5px;
        padding: 6px 26px 6px 17px;
    }

    .hello {
        width: 100%;
        height: 500px;
    }

    .card-item {
        padding: 18px;
        border-radius: 6px;
    }

    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }

    .ml-32px {
        margin-left: 32px;
    }

    #territoryDiv {
        width: 100%;
        height: 365px;
        background-image: linear-gradient(to bottom, #003e96, #001f4b);
    }

    #convertedLeadDiv {
        width: 100%;
        height: 405px;
    }

    #convertedDataDiv {
        width: 100%;
        height: 200px;
    }

    #campaignDiv {
        width: 100%;
        height: 340px;
    }

    #targetDiv {
        width: 100%;
        height: 340px;
    }

    #contactDiv {
        width: 100%;
        height: 400px;
    }

    .logo-image {
        width: 40px;
        height: 55px;
    }

    .contracts-logo {
        position: relative;
        bottom: 20px;
    }

    .pb-10px {
        padding-bottom: 10px;
    }

    .ongoing-survey-logo-image {
        width: 40px;
        height: 55px;
    }

    .meetings {
        border: 1px solid #005dae;
        border-radius: 4px;
        padding-top: 8px;
    }

    #targetachievedDiv {
        width: 100%;
        height: 300px;
    }

    #trendsDiv {
        width: 100%;
        height: 345px;
    }

    #salesValue {
        width: 100%;
        height: 340px;
    }

    .text-rotate {
        transform: rotate(-90deg);
        position: relative;
        right: 316px;
        top: 150px;
    }
    table thead th,
    table tbody td {
        padding: 10px;
    }

    #days {
        cursor: pointer;
    }

    .expand-img {
        width: 18px;
        margin-bottom: 2px;
    }

    .today-meetings {
        min-height: 377px;
        max-height: 377px;
        overflow: auto;
    }

    .icon-images {
        width: 24px;
        padding-right: 10px;
    }

    .copy-icon-images {
        width: 30px;
    }

    .mediaDiv {
        border: 1px solid #6491cb;
        border-radius: 2px;
        height: 200px
    }

    .icon_div {
        background-color: #ffe1dd;
        border: 1px solid #ccc;
        color: #ef1747;
    }

    .icon_div_green {
        background-color: #cce8e0;
        border: 1px solid #ccc;
        color: #008a63;
    }

    .contactMedia {
        width: 100%;
        height: 280px !important;
    }

    .new-blue {
        color: #00448b !important;
    }

    .slant-tabs {
        position: relative;
        height: 40px;
        min-width: 100px !important;
        text-align: center;
        line-height: 44px;
        color: #7b7f97;
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .new-blue {
        background-color: #e5eaed
    }

    .div-space {
        padding-right: 8px !important;
        padding-left: 5px !important;
    }

    .text-data {
        text-transform: capitalize !important;
    }

    .dropdown-button {
        background-color: #fff !important;
        height: 30px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 1.5rem;
    }

    .dropdown-button:focus {
        border: 1px solid #0F5DAF !important;
    }

    .dropdown-toggle::after {
        font-size: 20px;
    }

    .dropdown-button span {
        color: #000;
        font-weight: 400;
    }

    .dropdown-submenu {
        position: relative;
        padding: 0;
    }

    .dropdown-item-toggle {
        margin-right: 5px;
    }

    .dropdown-item-toggle::after {
        position: absolute;
        right: 7px;
        content: '▸';
        color: #aaa;
        margin-left: 0.5rem;
    }

    .dropdown-menu {
        top: 4px !important;
        left: 10px !important;
        margin-top: -1px;
        border-radius: 8px;
    }

    .sub-dropdown {
        left: -80% !important;
        width: 78%;
        margin: 0px;
        padding: 0px;
    }

    .dropdown-label {
        font-size: 16px;
        font-weight: 400;
        margin-right: 8px;
    }

    .select-css {
        border-radius: 6px;
        border: 0.6px solid #d7dae2 !important;
    }

    .el-select.drop-data .el-input__icon {
        line-height: 0px !important
    }

    .box-radius {
        border-radius: 7px !important;
    }

    .trendsDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 0 !important;
    }

    .contactDiv-expand {
        width: 100%;
        height: 600px !important;
        margin: auto;
        vertical-align: middle;
    }

    #historyDiv {
        height: 90px !important;
    }

    .trendsDiv-expand,
    .territoryDiv-expand,
    .convertedLeadDiv-expand,
    .historyDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 90
    }

    #salesValue {
        width: 100%;
        height: 400px;
    }

    .table-lead {
        border-collapse: collapse;
        width: 100%;
        height: 870px;
    }

    table thead th {
        padding: 10px;
        letter-spacing: 0.86px;
    }

    table.table-lead tbody tr {
        border-bottom: solid 1px #f2f3f5;
    }

    table.table-lead tbody td {
        padding: 16px 10px !important;
        font-size: 14px;
        color: #206ad3;
    }

    .badgelead {
        display: inline-block;
        padding: 6px 6px;
        font-size: 13px;
        font-weight: normal;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        -webkit-border-radius: 4px;
        border-radius: 4px;
        width: 100px;
    }

    .badgelead-hotlead {
        background: #fce5e5;
        border: 0.5px solid #e82828;
        color: #e82828;
    }

    .badgelead-coldlead {
        background: #c5daf8;
        border: 0.5px solid #206ad3;
        color: #206ad3;
    }

    .badgelead-warmlead {
        background: #ffecd1;
        border: 0.5px solid #ff9a06;
        color: #ff9a06;
    }
    .leadFullscreen.fullscreen {
        overflow-y:scroll !important;
    }
    .leadFullscreen.fullscreen .text-lead-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 300px;
        width: 300px;
        white-space: nowrap;
    }

    .leadFullscreen.fullscreen .text-lead-ellipsis-company {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
        width: 200px;
        white-space: nowrap;
    }
    .list-lead-img{
        width: 100% !important;
        height: 50% !important;
        margin-top: -300px !important;
    }
    #legenddiv {
        height: 34px;
        width: 90%;
        position: absolute;
        bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/LeadsDashboard.vue